<template>
    <div class="_heroContent">
        <div class="_heroIn">

            <!-- Our Mission is to Simplify Implant Dentistry. -->
            <div class="_heroLine">{{localize('hp_maintitle')}}</div>

            <div class="_heroText">
                {{localize('hp_subtitle1')}} {{localize('hp_subtitle2')}}
            </div>

            <svg class="_heroLogo" viewBox="1.0822 0.119 374.7805 39" xmlns="http://www.w3.org/2000/svg">
                <g transform="matrix(0.5006420016288757, 0, 0, 0.5006420016288757, -253.84474182128906, -186.0697479248047)"  >
                <g>
                    <g>
                    <path class="cls-1" d="M667.3,443.5h-54.9s0-5.5,0-5.5h54.8c5.4,0,9.8-4,9.8-8.9s-3.3-7.9-7.8-8.8c-1.3-.3-2.7-.6-4.4-.9,0,0-4.1-.4-15-1.7-9-1-13.6-1.4-25-2.8-1.7-.2-2.5-.3-4.5-.8-2.3-.5-3.9-1.4-5.8-2.7-2.1-1.5-2.4-3.6-2.4-6.1,0-5,3.9-9.2,8.9-9.2h20.4v5.5c-7.5,0-11.2,0-19.2,0-2.1,0-3.8,1.6-3.8,3.7s.9,2.7,2.4,3.3c1.4,.5,6.9,1.1,9,1.4,1.5,.3,20,2.3,20,2.3,0,0,18.1,2.2,19.4,2.4,8.1,1,13.7,6.9,13.7,14.4s-6.7,14.5-15,14.5h-.6s0,0,0,0Z" style="fill: rgb(0, 110, 184); fill-rule: evenodd;"/>
                    <path class="cls-1" d="M667.3,443.5h-54.9s0-5.5,0-5.5h54.8c5.4,0,9.8-4,9.8-8.9s-3.3-7.9-7.8-8.8c-1.3-.3-2.7-.6-4.4-.9,0,0-4.1-.4-15-1.7-9-1-13.6-1.4-25-2.8-1.7-.2-2.5-.3-4.5-.8-2.3-.5-3.9-1.4-5.8-2.7-2.1-1.5-2.4-3.6-2.4-6.1,0-5,3.9-9.2,8.9-9.2h20.4v5.5c-7.5,0-11.2,0-19.2,0-2.1,0-3.8,1.6-3.8,3.7s.9,2.7,2.4,3.3c1.4,.5,6.9,1.1,9,1.4,1.5,.3,20,2.3,20,2.3,0,0,18.1,2.2,19.4,2.4,8.1,1,13.7,6.9,13.7,14.4s-6.7,14.5-15,14.5h-.6s0,0,0,0Z" style="fill: rgb(0, 110, 184); fill-rule: evenodd;"/>
                    <rect class="cls-2" x="597.4" y="371.9" width="5.5" height="18.2" style="fill: rgb(0, 110, 184);"/>
                    <rect class="cls-2" x="597.4" y="396.1" width="5.6" height="47.7" style="fill: rgb(0, 110, 184);"/>
                    <rect class="cls-2" x="597.4" y="371.9" width="5.5" height="18.2" style="fill: rgb(0, 110, 184);"/>
                    <rect class="cls-2" x="597.4" y="396.1" width="5.6" height="47.7" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-1" d="M552.3,444h-5.6s0-39.6,0-39.6c0-1.1-.4-2.3-1.3-2.9-.7-.5-1.6-.6-2.2-.6-1,0-1.8,0-3.5,2.6l-23.6,40.4h-6.8s5.7-9.9,5.7-9.9c2.2-2.6,17.9-30.5,17.9-30.5,3-4.8,5.2-7.5,8.8-7.7,1.3,0,1.9-.2,3.2,0,1.9,.2,2.8,.7,4,1.6,1,.7,1.7,1.6,2.3,2.7,.7,1.2,1,2.5,1,3.9,0,12.7,0,17.4,0,28.4,4.1-6.4,16.8-29,16.8-29,3-4.8,5.2-7.5,8.8-7.7,1.3,0,1.9-.2,3.2,0,1.9,.2,2.7,.7,4,1.6,1,.7,1.7,1.6,2.3,2.7,.7,1.2,1,2.5,1,3.9,0,15.5,0,24.2,0,39.7h-5.6v-39.4c0-1.1-.4-2.3-1.3-2.9-.7-.5-1.6-.6-2.2-.6-1,0-1.8,0-3.5,2.6l-23.6,40.4Z" style="fill: rgb(0, 110, 184); fill-rule: evenodd;"/>
                    </g>
                    <path class="cls-2" d="M648.7,394.2c.8,0,1.5,.2,2.3,.6,.7,.4,1.3,1,1.7,1.7s.6,1.5,.6,2.3-.2,1.6-.6,2.3c-.4,.7-1,1.3-1.7,1.7-.7,.4-1.5,.6-2.3,.6s-1.6-.2-2.3-.6c-.7-.4-1.3-1-1.7-1.7-.4-.7-.6-1.5-.6-2.3s.2-1.6,.6-2.3c.4-.7,1-1.3,1.7-1.7,.7-.4,1.5-.6,2.3-.6Zm0,.8c-.7,0-1.3,.2-1.9,.5s-1.1,.8-1.5,1.4c-.4,.6-.5,1.3-.5,1.9s.2,1.3,.5,1.9c.3,.6,.8,1.1,1.4,1.4,.6,.3,1.3,.5,1.9,.5s1.3-.2,1.9-.5c.6-.3,1.1-.8,1.4-1.4,.3-.6,.5-1.3,.5-1.9s-.2-1.3-.5-1.9c-.3-.6-.8-1.1-1.5-1.4s-1.3-.5-1.9-.5Zm-2,6.5v-5h1.7c.6,0,1,0,1.3,.1,.3,0,.5,.3,.6,.5s.2,.5,.2,.7-.1,.7-.4,1c-.3,.3-.6,.4-1,.5,.2,0,.3,.2,.4,.3,.2,.2,.4,.5,.7,1l.6,1h-1l-.4-.8c-.4-.6-.6-1-.8-1.2-.1-.1-.4-.2-.6-.2h-.5v2.1h-.8Zm.8-2.8h1c.5,0,.8,0,1-.2,.2-.1,.3-.3,.3-.6s0-.3-.1-.4c0-.1-.2-.2-.3-.3-.1,0-.4,0-.8,0h-.9v1.5Z" style="fill: rgb(0, 110, 184);"/>
                </g>

                <!-- MAKE IT SIMPLE -->
                <g>
                    <path class="cls-2" d="M723.2,444.6v-48h9.6l11.4,34c1,3.2,1.8,5.5,2.3,7.1,.5-1.7,1.4-4.3,2.6-7.7l11.5-33.4h8.5v48h-6.1v-40.2l-14,40.2h-5.7l-13.9-40.9v40.9h-6.1Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M774.8,444.6l18.4-48h6.8l19.7,48h-7.2l-5.6-14.5h-20.1l-5.3,14.5h-6.7Zm13.9-19.7h16.3l-5-13.3c-1.5-4-2.7-7.4-3.4-10-.6,3.1-1.5,6.1-2.6,9.2l-5.3,14.1Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M825.2,444.6v-48h6.4v23.8l23.8-23.8h8.6l-20.1,19.5,21,28.6h-8.4l-17.1-24.3-7.9,7.7v16.6h-6.4Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M871.1,444.6v-48h34.7v5.7h-28.4v14.7h26.6v5.6h-26.6v16.3h29.5v5.7h-35.8Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M936.9,444.6v-48h6.4v48h-6.4Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M967.4,444.6v-42.3h-15.8v-5.7h38.1v5.7h-15.9v42.3h-6.4Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M1012.9,429.2l6-.5c.3,2.4,.9,4.4,2,5.9,1,1.5,2.6,2.8,4.8,3.7,2.2,.9,4.6,1.4,7.4,1.4s4.6-.4,6.4-1.1c1.9-.7,3.2-1.7,4.1-3,.9-1.3,1.4-2.6,1.4-4.1s-.4-2.8-1.3-3.9c-.9-1.1-2.3-2.1-4.3-2.8-1.3-.5-4.1-1.3-8.5-2.3-4.4-1.1-7.5-2.1-9.3-3-2.3-1.2-4-2.7-5.1-4.5-1.1-1.8-1.7-3.8-1.7-6s.7-4.7,2.1-6.8c1.4-2.1,3.4-3.7,6-4.8,2.6-1.1,5.6-1.6,8.8-1.6s6.7,.6,9.4,1.7c2.7,1.1,4.8,2.8,6.3,5.1,1.5,2.2,2.2,4.7,2.4,7.6l-6.1,.5c-.3-3-1.4-5.3-3.3-6.9-1.9-1.5-4.7-2.3-8.4-2.3s-6.6,.7-8.4,2.1-2.6,3.1-2.6,5.1,.6,3.1,1.9,4.3c1.2,1.1,4.4,2.3,9.6,3.4,5.2,1.2,8.7,2.2,10.6,3.1,2.8,1.3,4.9,2.9,6.2,4.9s2,4.3,2,6.8-.7,5-2.2,7.2-3.6,4-6.3,5.3-5.8,1.9-9.3,1.9-8-.6-10.9-1.9c-2.9-1.3-5.2-3.2-6.9-5.7s-2.5-5.4-2.6-8.6Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M1061.6,444.6v-48h6.4v48h-6.4Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M1079.7,444.6v-48h9.6l11.4,34c1,3.2,1.8,5.5,2.3,7.1,.5-1.7,1.4-4.3,2.6-7.7l11.5-33.4h8.5v48h-6.1v-40.2l-14,40.2h-5.7l-13.9-40.9v40.9h-6.1Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M1136.5,444.6v-48h18.1c3.2,0,5.6,.2,7.3,.5,2.4,.4,4.3,1.1,5.9,2.2,1.6,1.1,2.9,2.6,3.8,4.6s1.5,4.2,1.5,6.5c0,4.1-1.3,7.5-3.9,10.4-2.6,2.8-7.3,4.2-14.1,4.2h-12.3v19.5h-6.4Zm6.4-25.2h12.4c4.1,0,7-.8,8.7-2.3s2.6-3.7,2.6-6.5-.5-3.7-1.5-5.2c-1-1.4-2.4-2.4-4-2.8-1.1-.3-3-.4-5.9-.4h-12.3v17.2Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M1181.7,444.6v-48h6.4v42.3h23.6v5.7h-30Z" style="fill: rgb(0, 110, 184);"/>
                    <path class="cls-2" d="M1220.2,444.6v-48h34.7v5.7h-28.4v14.7h26.6v5.6h-26.6v16.3h29.5v5.7h-35.8Z" style="fill: rgb(0, 110, 184);"/>
                </g>

                <line class="cls-3" x1="701.4" y1="388.5" x2="701.4" y2="452.5" style="fill: none; stroke: rgb(0, 110, 184); stroke-miterlimit: 10; stroke-width: 3px;"/>
                </g>
            </svg>
            
            <!-- explore -->
            <!-- @click="scrollToVideo" -->
            <div class="center text-center btnExWrapper">
                <a class="btnExplore" href="https://www.mis-implants.com/company/story-and-values" >
                    <span>{{localize('our_story')}}</span>
                    <i class="fal fa-chevron-right"></i>
                </a>
            </div>



        </div>
    </div>        
</template>

<script>
    export default {
        methods:{
            scrollToVideo()
            {
                const id = 'homeHeroVideo1';
                const yOffset = -150; 
                const element = document.getElementById(id);
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});

                //document.getElementById("homeHeroVideo1").scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

</script>


<style>
    .btnExWrapper
    {
        margin-top: 2.5vw;
        margin-bottom: 2.5vw;
    }
    ._heroContent
    {
        width: 100%;
        height: 60vh;
        text-align: center;
        display: flex;
        align-items: center;  
    }
    ._heroIn
    {
        margin: auto;
        width: 60vw;
    }
    ._heroLogo
    {
        padding-top: 20px;
      width: 20vw;
      height: auto;
      margin: auto;
      display: block;
    }
    ._heroLine
    {
        padding-top: 0px;
        display: block;
        clear: both;
        font-size: 5vw;
        line-height: 5vw;
        color:#0f70b6;
        text-align: center;
        width: 100%;
        font-weight: 300 !important;
        letter-spacing: -0.4vw !important;
    }
    ._heroText
    {
        padding-top: 40px;
        display: block;
        clear: both;
        font-size: 18px;
        color: #414141;
        text-align: center;
        width: 40vw;
        margin: auto;
        font-weight: 300 !important;
        letter-spacing: -0.5px !important;
    

    }
    .btnExplore
    {
        cursor:pointer;
        position:relative;
        border:1px solid #202020;
        text-align:left;
        padding:10px 20px;
        border-radius:20px;
        transition: all ease 0.4s;      
    }
    .btnExplore span
    {
        color:#202020;
        font-size: 14px;
        font-weight: 300 !important;
        padding-right: 10px;
    }
    .btnExplore i
    {
        color:#202020;
        font-size: 14px;
        font-weight: 300 !important;
    }
    .btnExplore:hover
    {
        color:#fff;
        border:1px solid #202020;
        background-color: #30a9f6;
        border:1px solid #30a9f6;
    }
    .btnExplore:hover span
    {
        color:#fff;
    }

    .btnExplore:hover i
    {
        color:#fff;
    }

    @media screen and (min-width: 1900px) {
        ._heroText
        {
            width: 50%;
            margin: auto;
        }
    }
    
    /* Portrait ipad pro */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) {
        ._heroContent {
            margin: 10vw 0 5vw 0px;
            height: auto;
        }        
      }       

    /* ----------- mobile ----------- */
    @media screen and (max-width: 815px) {
        ._heroContent{height: auto;}
        ._heroIn {width: 80vw;}        
        ._heroLogo{width: 70vw;padding: 30px 0px;}
        ._heroLine{
            padding-top: 10vw;
            font-size: 11vw;
            line-height: 11vw;
        }
        ._heroText
        {
            width: 100%;
        }
        .btnExWrapper
        {
            padding-bottom: 30px;
        }
        .btnExplore
        {
            /* display: none; */
        }
    }


</style>